import React, { Component } from "react";
import { Menu, MenuItem, IconButton } from "@material-ui/core";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import swal from "sweetalert";
 import { SemipolarLoading } from "react-loadingg";
class ExportToMonitoring extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, anchorEl: null, fileName: "Engaged" };
  }

  ExcelRecieveddateFomate = date => {
    if (date !== null && date !== undefined) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      let time1 = date.getTime();
      let time2 = date.getTimezoneOffset() * 60000;
      date = time1 + time2;
      date = new Date(date);

      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();

      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

      let date1 = `${dd}/${mm}/${yyyy}`;
      let time = hours + ":" + minutes + " " + am_pm;

      return (date = date1 + " " + time);
    }
  };

  formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };

  formatDate1 = date => {
    if (date !== null && date !== undefined) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "PM" : "AM";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let time = hours + ":" + minutes + " " + am_pm;
      date = `${dd}/${mm}/${yyyy}`;
      return (date = date + " " + time);
    }
  };
  exportToClick = event => {
    this.setState({ anchorEl: event.currentTarget });
    event.stopPropagation();
  };

  exportToClose = () => {
    this.setState({ anchorEl: null });
  };


  setDataWithHeader = fileData => {
    let filedata = [];
    fileData.length > 0
      ? fileData.map(item => {
          return filedata.push({
            Customer: item.customerIbfk1rel.Customers[0].company,
            LinkedinProfile: item.customercredentialsIbfk1rel.Customerlinkedinprofiles[0].name,
            CampaignName: item.name,
            CamapignStatus: item.status,
            LinkedinType: item.salesNavigator === 0 ? "Linkedin" : "SalesNavigator",
            Target: item.targetconnections,
            Startdate: this.formatDate(item.startdate),
            Running: item.runningCampaign === 0 ? "stop" : "Running",
            InvitedCount: item.invitedcount,
            ConnectedCount: item.connectedcount,
            ConnectedPercent: item.connectedper,
            EngagedCount: item.engagedcount,
            EngagedPercent: item.engagedper,
            LeadCount: item.leadcount,
            LeadPercent: item.leadper,
            CampaignType: item.type,         
            InviteLimitPerday: item.invitelimit,
            FreeContact: item.freecontact,
            InviteToday: item.invitetoday,
            TodayInviteOutOf: item.todayStatus,
            WeekReqfree: item.weekreqfree,      
            LastLogin: item.loginTime, 
            LastLogout: item.logoutTime, 
            
          });
        })
      : filedata.push({
          Name: "",
          "First Name": "",
          "Current Company": "",
          "Current Position": "",
          Location: "",
          Industry: "",
          "Linkedin Url": "",
          Email: "",
          "Phone ": "",
          Twitter: "",
          Skype: "",
          DOB: "",
          Visit: "",
          Follow: "",
          "Invitation Sent": "",
          "Connected On": "",
          "Current Stage": "",
          "Last Response": "",
          Status: ""
        });
    return filedata;
  };

  exportToExcel = (selectedData, fileName) => {
    if (selectedData && selectedData.length > 0) {

      let filedata = this.setDataWithHeader(this.props.fileData);
      try {
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const name = "Monitoring";
        const ws = XLSX.utils.json_to_sheet(filedata);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, {
          bookType: "xlsx",
          type: "array"
        });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, name + fileExtension);

        this.exportToClose();
      } catch (e) {
        swal("Error", { icon: "error" });
      }
      this.setState({ loading: false });
     }
    else {
      this.setState({ loading: true });
      setTimeout(() => {
        this.exportToExcel(this.props.fileData, fileName);
      }, 5000);
    }
  };


  render() {
    if (this.state.loading) {
      return (
        <div className="spinner">
          <SemipolarLoading size={70} color={"#3865dd"} />
        </div>
      );
    }
    const { anchorEl, fileData, fileName } = this.state;
    return (
      <div class="Export">
        <IconButton
          style={{ fontSize: "1rem", color: "#36454d" }}
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={this.exportToClick}
        >
          Export as
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={this.exportToClose}
        >
          <MenuItem onClick={this.exportToClose} disabled>
            Export to
          </MenuItem>
       
          <MenuItem
            onClick={() => {
              this.exportToExcel(this.props.fileData, fileName);
              // this.exportToExcel(this.props.SalesHubdata, fileName);
            }}
          >
            Excel
          </MenuItem>
        
        </Menu>
      </div>
    );
  }
}

export default ExportToMonitoring;
